import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { motion } from 'framer-motion';
import { useLanguage } from '../i18n/LanguageContext';
export function GuaranteeSection() {
  const {
    t
  } = useLanguage();
  return <section id="garantia" className="py-20 bg-white" data-id="element-139">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-140">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-black rounded-3xl p-8 md:p-16 text-center relative overflow-hidden border-4 border-brand-gold" data-id="element-141">
          {/* Decorative background elements */}
          <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-142">
            <div className="absolute -top-24 -right-24 w-64 h-64 bg-brand-gold rounded-full blur-[80px]" data-id="element-143"></div>
            <div className="absolute -bottom-24 -left-24 w-64 h-64 bg-brand-gold rounded-full blur-[80px]" data-id="element-144"></div>
          </div>

          <div className="relative z-10" data-id="element-145">
            <ShieldCheck className="w-20 h-20 text-brand-gold mx-auto mb-8" data-id="element-146" />

            <h2 className="text-2xl md:text-3xl font-bold text-brand-gold uppercase tracking-widest mb-6" data-id="element-147">
              {t('guarantee.title')}
            </h2>

            <p className="text-white/80 text-lg mb-8 max-w-2xl mx-auto" data-id="element-148">
              {t('guarantee.p1')}
            </p>

            <h3 className="text-3xl md:text-5xl font-serif font-bold text-white leading-tight mb-8 text-balance" data-id="element-149">
              {t('guarantee.quote')}
            </h3>

            <div className="space-y-4 text-lg text-white/70 max-w-3xl mx-auto" data-id="element-150">
              <p data-id="element-151">{t('guarantee.p2')}</p>
              <p className="font-bold text-white" data-id="element-152">{t('guarantee.p3')}</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}